<template>
  <div class="login-page">
    <div class="login-page__background">
      <img
        :src="backgroundImg"
        alt=""
      >
    </div>
    <div class="login-page__overlay" />

    <main class="login-page__main">
      <LoginForm />
    </main>
  </div>
</template>

<script>
import LoginForm from '../forms/LoginForm'
import backgroundImg from '../../assets/login-bg/och_power_racks.jpg'

export default {
  name: 'Login',
  components: { LoginForm },
  data: () => ({
    backgroundImg
  }),
  computed: {},
  created () {
    this.$store.dispatch('clearErrorRes')
  },
  methods: {}
}
</script>

<style scoped>
.login-page {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100dvh;
  min-height: 100dvh;
  overflow: hidden;
}

.login-page__background {
  position: fixed;
  inset: 0;
  z-index: 0;
}

.login-page__background img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.login-page__overlay {
  position: fixed;
  inset: 0;
  z-index: 1;
  background: rgba(10, 15, 30, 0.65);
  backdrop-filter: blur(4px);
}

.login-page__main {
  position: relative;
  z-index: 2;
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  min-height: 0;
  max-height: 100%;
  padding: clamp(16px, 3vh, 24px) 16px;
  box-sizing: border-box;
  overflow: hidden;
}
</style>
